<template>
    <user-dashboard-layout>
        <div class="edit-content">
            <div class="edit-top">
                <h4 class="edit-title">Edit Keyword</h4>
                <BaseInput
                    v-model="keyword.text"
                    :error="errors['keyword.text']"
                    placeholder="Keyword Name"
                    gray="gray"
                    class="edit-top__input"
                />
                <div>
                  <multiselect
                    v-model="keyword.search_in"
                    :options="search_in_options"
                    :searchable="false"
                    :show-labels="false"
                    label="text"
                    placeholder="Choose Search Area"
                  ></multiselect>
                </div>
            </div>
            <div
                class="items"
                :class="{ 'items_not-upwork': !isUpworkPlatform }"
            >
                <div class="item item-1">
                    <div class="item-1__content">
                        <div class="item-1__body">
                            <div class="item-1__line">
                                <label for="">Time {{ weekday }}</label>
                                <multiselect
                                    v-model="weekday"
                                    :options="days"
                                    :searchable="false"
                                    :show-labels="false"
                                    placeholder="Select day"
                                ></multiselect>
                                <ErrorField :error="weekdayError['weekday']" />
                            </div>
                            <div class="item-1__box">
                                <div class="item-1__line">
                                    <label for="">From</label>
                                    <multiselect
                                        v-model="start_at"
                                        :options="timeFrom"
                                        :searchable="false"
                                        :show-labels="false"
                                        placeholder="From"
                                    ></multiselect>
                                    <ErrorField :error="fromError['from']" />
                                </div>
                                <div class="item-1__line">
                                    <label for="">To</label>
                                    <multiselect
                                        v-model="end_at"
                                        :options="timeTo"
                                        :searchable="false"
                                        :show-labels="false"
                                        placeholder="To"
                                    ></multiselect>
                                    <ErrorField :error="toError['to']" />
                                </div>
                            </div>
                            <Button
                                @click="addPeriod"
                                class="item-1__add-button"
                                >Add</Button
                            >
                        </div>
                    </div>
                    <div>
                        <div class="d-flex justify-end">
                            <span class="item-10__box mt-4">
                                <span>Always send</span>
                                <ToggleSwitch v-model="keyword.always_send" />
                            </span>
                        </div>
                        <ul
                            v-if="periods.length > 0 && !keyword.always_send"
                            class="item-1__items"
                        >
                            <li
                                v-for="(item, key) in periods"
                                :key="item.key"
                                class="item-1__item"
                            >
                                <span>
                                    {{ item.weekday }}:
                                    <strong>{{
                                        item.start_at.substring(0, 5)
                                    }}</strong>
                                    <strong>- </strong>
                                    <strong>{{
                                        item.end_at.substring(0, 5)
                                    }}</strong>
                                </span>
                                <img
                                    @click="removePeriod(key)"
                                    src="@/assets/images/icons/close-red.svg"
                                    alt="Delete"
                                />
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="item item-2">
                    <div class="item-2__line">
                        <label for="">Category</label>
                        <multiselect
                            v-model="category_type"
                            :options="category_types"
                            :searchable="false"
                            :show-labels="false"
                            label="name"
                            placeholder="Select Category"
                        ></multiselect>
                        <ErrorField />
                    </div>
                </div>
                <div class="item item-3">
                    <div class="item-3__line">
                        <label for="">Platform</label>
                        <multiselect
                            v-model="keyword.platform"
                            :options="platforms"
                            :searchable="false"
                            :show-labels="false"
                            :class="{
                                'multiselect-error': errors['keyword.platform']
                            }"
                            placeholder="Select Platform"
                        ></multiselect>
                        <ErrorField :error="errors['keyword.platform']" />
                    </div>
                </div>
                <div v-if="isUpworkPlatform" class="item item-4">
                    <div class="item-4__line">
                        <label for="">Except countries</label>
                        <multiselect
                            v-model="except_country"
                            @select="addCountry"
                            :options="allCountries"
                            :searchable="true"
                            :show-labels="false"
                            placeholder="Except countries"
                        ></multiselect>
                        <ErrorField />
                    </div>
                    <ul
                        v-if="keyword.except_countries.length > 0"
                        class="item-4__items"
                    >
                        <li
                            v-for="country in keyword.except_countries"
                            :key="country"
                            class="item-4__item"
                        >
                            {{ country }}
                            <img
                                @click="removeCountry(country)"
                                src="@/assets/images/icons/close-white.svg"
                                alt="Delete country"
                            />
                        </li>
                    </ul>
                </div>
                <div v-if="isUpworkPlatform" class="item item-5">
                    <div class="item-5__line">
                        <label for="">Client minimum rating</label>
                        <Rating v-model="keyword.min_client_rating" />
                        <ErrorField />
                    </div>
                </div>
                <div v-if="isUpworkPlatform" class="item item-6">
                    <div class="item-6__line">
                        <label for="">Client minimum hires</label>
                        <BaseInput
                            v-model="keyword.min_client_hires"
                            :error="errors['keyword.min_client_hires']"
                            type="number"
                            placeholder="Minimum count of hires"
                        />
                    </div>
                </div>
                <div class="item item-7">
                    <div class="item-7__line">
                        <label for="">Minus Keywords</label>
                        <BaseInput
                            :addInput="true"
                            v-model.trim="minus_keyword"
                            @add-update="addMinusKeyword"
                            type="text"
                            class="item-7__input"
                            placeholder="Minus Keyword"
                        />
                    </div>
                    <ul
                        v-if="keyword.minus_keywords.length"
                        class="item-7__items"
                    >
                        <li
                            v-for="(item, key) in keyword.minus_keywords"
                            :key="item.key"
                            class="item-7__item"
                        >
                            {{ item }}
                            <img
                                @click="removeMinusKeyword(key)"
                                src="@/assets/images/icons/close-white.svg"
                                alt="Delete keyword"
                            />
                        </li>
                    </ul>
                </div>
                <div class="item item-8">
                    <label class="item-8__label">Notifications</label>
                    <div class="item-8__line">
                        <div class="item-8__box">
                            <ToggleSwitch
                                v-model="notifications.slack.is_active"
                            />
                            <span class="text-span">Slack channel</span>
                        </div>
                        <div v-if="notifications.slack.is_active">
                            <BaseInput
                                v-model="notifications.slack.slack_channel"
                                :error="errors['notifications.slack.slack_channel']"
                                type="text"
                                placeholder="Slack channel"
                                class="item-8__input"
                            />
                            <div class="item-8__notification-instruction">
                                <v-icon
                                    size="medium">
                                    mdi-wrench
                                </v-icon>
                                <p class="item-8__notification-instruction__text"  >Connect your Slack workspace to our platform by clicking the button 
                                    'Connect Slack' on Settings page(If you haven't already done). 
                                    Then, run the command '/invite @LeadProHub' in your desired channel. 
                                    Then please enter your channel name here.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="item-8__line">
                        <div class="item-8__box">
                            <ToggleSwitch
                                v-model="notifications.telegram.is_active"
                            />
                            <span class="text-span">Telegram</span>
                        </div>
                        <div v-if="notifications.telegram.is_active">
                            <BaseInput
                                v-model="notifications.telegram.telegram_id"
                                :error="
                                    errors['notifications.telegram.telegram_id']
                                "
                                type="text"
                                placeholder="Telegram id"
                                class="item-8__input"
                            />
                            <div class="item-8__notification-instruction">
                                <v-icon
                                    size="medium">
                                    mdi-wrench
                                </v-icon>
                                <p class="item-8__notification-instruction__text">If you are going to use Telegram for notifications 
                                    follow this <a href="http://t.me/KeywordProposalBot " target="_blank">bot</a> and type /start. 
                                    Then get your own ID and put it here.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="item-8__line">
                        <div class="item-8__box">
                            <ToggleSwitch
                                v-model="notifications.email.is_active"
                            />
                            <span class="text-span">E-mail</span>
                        </div>
                        <BaseInput
                            v-if="notifications.email.is_active"
                            v-model="notifications.email.email"
                            :error="errors['notifications.email.email']"
                            type="text"
                            placeholder="email"
                        />
                    </div>
                </div>
                <div class="item item-9">
                    <div class="item-9__top">
                        <label for="" class="item-9__label"
                            >Proposal text</label
                        >
                        <div class="item-9__line">
                            <ToggleSwitch
                                v-model="keyword.is_using_ai_proposal"
                            />
                            <span class="text-span"
                                >use AI to generate proposal text</span
                            >
                        </div>
                        <div
                            v-if="!keyword.is_using_ai_proposal"
                            style="margin-bottom: 16px"
                        >
                            <BaseTextArea
                                v-model="keyword.proposal_text"
                                :error="errors['keyword.proposal_text']"
                                cols="40"
                                rows="7"
                                placeholder="text"
                            />
                        </div>
                        <div class="item-9__line">
                            <Checkbox
                                v-model="keyword.show_portfolio_items"
                                :id="'itms_1'"
                                :label="'Add portfolio items to proposal text'"
                            />
                        </div>
                        <div v-if="keyword.is_using_ai_proposal">
                            <label for=""
                                style="
                                margin: 25px 0px 10px;
                                "
                            >Special instruction to AI</label>
                            <BaseTextArea
                                v-model="keyword.ai_special_instruction"
                                :error="errors['keyword.ai_special_instruction']"
                                cols="40"
                                rows="3"
                                placeholder="text"
                            />
                            <div class="item-9__item item-9__item__cover-letter">
                                <label for=""
                                    >Required text length (words)</label>
                                <BaseInput
                                    v-model="keyword.proposal_text_length"
                                    type="number"
                                    :error="errors['keyword.proposal_text_length']"
                                    placeholder="Words count"
                                    class="item-9__input"
                                />
                            </div>
                        </div>
            
                    </div>
                    <div class="item-9__bottom">
                        <div class="item-9__bottom-text">Project Types</div>
                        <div class="item-9__items">
                            <div class="item-9__item">
                                <Checkbox
                                    v-model="keyword.is_active_fixed_price"
                                    :id="'f_p'"
                                    :label="'fixed price'"
                                    class="item-9__checkbox"
                                />
                                <BaseInput
                                    v-model="keyword.fixed_price_minimum_budget"
                                    type="number"
                                    gray="gray"
                                    placeholder="Min budget"
                                    class="item-9__input"
                                />
                            </div>
                            <div class="item-9__item">
                                <Checkbox
                                    v-model="keyword.is_active_hourly"
                                    :id="'h_p'"
                                    :label="'hourly'"
                                    class="item-9__checkbox"
                                />
                                <BaseInput
                                    v-model="keyword.hourly_minimum_rate"
                                    type="number"
                                    placeholder="Min budget"
                                    gray="gray"
                                    class="item-9__input"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item item-10">
                    <label v-if="isUpworkPlatform" class="item-10__label">
                        Manager Name
                    </label>
                    <div class="item-10__line">
                        <BaseInput
                            v-if="isUpworkPlatform"
                            v-model="keyword.manager_name"
                            :disabled="keyword.is_active ? false : true"
                            placeholder="Manager Name"
                            gray="gray"
                            class="item-10__input"
                        />
                        <div class="item-10__box">
                            <span class="text-span">Active</span>
                            <ToggleSwitch v-model="keyword.is_active" />
                        </div>
                    </div>
                </div>
            </div>
            <Button @click="save" class="save-btn"> Save </Button>
        </div>
    </user-dashboard-layout>
</template>

<script>
import UserDashboardLayout from "@/layouts/UserDashboardLayout.vue";
import Multiselect from "vue-multiselect";
import Button from "@/components/ui/Button.vue";
import ToggleSwitch from "@/components/ui/ToggleSwitch.vue";
import Checkbox from "@/components/ui/Checkbox.vue";
import Rating from "@/components/ui/Rating.vue";
import BaseInput from "@/components/ui/BaseInput.vue";
import BaseTextArea from "@/components/ui/BaseTextArea.vue";
import ErrorField from "@/components/ui/ErrorField.vue";

export default {
    components: {
        UserDashboardLayout,
        Multiselect,
        Button,
        ToggleSwitch,
        Checkbox,
        Rating,
        BaseInput,
        BaseTextArea,
        ErrorField
    },
    metaInfo() {
        return {
            title: this.keyword.text + " - Keywords"
        };
    },
    data() {
        return {
            isUpworkPlatform: false,

            search_in_options: [
              { value: 'q', text: 'Everywhere' },
              { value: 'title', text: 'Only in Title' }
            ],
            id: this.$route.params.id,
            keyword: {
                text: "",
                is_active: null,
                always_send: false,
                is_active_fixed_price: false,
                fixed_price_minimum_budget: 0,
                is_active_hourly: false,
                hourly_minimum_rate: 0,
                manager_name: "",
                platform: "",
                except_countries: [],
                is_using_ai_proposal: null,
                proposal_text: null,
                min_client_rating: null,
                min_client_hires: null,
                minus_keywords: [],
                show_portfolio_items: null,
                search_in: null,
                ai_special_instruction: null,
                proposal_text_length: 100
            },
            except_country: null,
            category_type: {
                id: null,
                name: null
            },
            periods: [],
            platforms: [],
            minus_keyword: null,
            weekday: "Sunday",
            start_at: null,
            end_at: null,
            category_types: [
                {
                    id: null,
                    name: "No category"
                }
            ],
            allCountries: [],
            notifications: {
                slack: {
                    id: null,
                    name: "slack",
                    is_active: false,
                    slack_channel: null
                },
                telegram: {
                    id: null,
                    name: "telegram",
                    is_active: false,
                    telegram_id: null
                },
                email: {
                    id: null,
                    name: "email",
                    is_active: false,
                    email: null
                }
            },
            days: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            time: [
                "00:00",
                "01:00",
                "02:00",
                "03:00",
                "04:00",
                "05:00",
                "06:00",
                "07:00",
                "08:00",
                "09:00",
                "10:00",
                "11:00",
                "12:00",
                "13:00",
                "14:00",
                "15:00",
                "16:00",
                "17:00",
                "18:00",
                "19:00",
                "20:00",
                "21:00",
                "22:00",
                "23:00"
            ],
            errors: {},
            weekdayError: {},
            fromError: {},
            toError: {}
        };
    },

    methods: {
        getData() {
            let allNotifications = this.notifications;
            window.axios
                .get("/api/keywords/" + this.id + "/edit")
                .then(res => {
                    this.keyword.platform = res.data.keyword.platform;
                    this.keyword.text = res.data.keyword.text;
                    this.keyword.manager_name = res.data.keyword.manager_name;
                    this.keyword.is_active = res.data.keyword.is_active;
                    this.keyword.always_send = res.data.keyword.always_send;
                    this.keyword.is_active_fixed_price =
                        res.data.keyword.is_active_fixed_price;
                    this.keyword.fixed_price_minimum_budget =
                        res.data.keyword.fixed_price_minimum_budget;
                    this.keyword.is_active_hourly =
                        res.data.keyword.is_active_hourly;
                    this.keyword.hourly_minimum_rate =
                        res.data.keyword.hourly_minimum_rate;
                    this.keyword.is_using_ai_proposal =
                        res.data.keyword.is_using_ai_proposal;
                    this.keyword.proposal_text = res.data.keyword.proposal_text;
                    this.keyword.show_portfolio_items =
                        res.data.keyword.show_portfolio_items;
                    this.periods = res.data.keyword.proposal_send_periods;
                    this.category_type.id =
                        res.data.keyword.category?.category_type.id;
                    this.category_type.name =
                        res.data.keyword.category?.category_type.name;
                    this.platforms = res.data.platforms;
                    this.allCountries = res.data.allCountries;
                    this.keyword.except_countries = res.data.exceptCountries;
                    this.keyword.min_client_rating =
                        res.data.keyword.min_client_rating;
                    this.keyword.min_client_hires =
                        res.data.keyword.min_client_hires;
                    this.keyword.search_in = res.data.keyword.search_in;
                    this.keyword.ai_special_instruction = res.data.keyword.ai_special_instruction;
                    this.keyword.proposal_text_length = res.data.keyword.proposal_text_length;

                    if (res.data.keyword.minus_keywords) {
                        this.keyword.minus_keywords =
                            res.data.keyword.minus_keywords;
                    }
                    if (res.data.keyword.search_in) {
                        this.keyword.search_in = this.search_in_options.find(option => option.value === res.data.keyword.search_in)
                    }
                    if (res.data.notifications.length) {
                        let notifications = res.data.notifications;
                        Object.values(notifications).forEach(function(value) {
                            allNotifications[value.name] = value;
                        });
                    }
                    this.notifications = allNotifications;
                });
        },

        getCategoryTypes() {
            window.axios.get("/api/category-types").then(res => {
                this.category_types = res.data.categoryTypes;
                this.category_types.push({ id: null, name: "No category" });
            });
        },

        addPeriod() {
            this.clearErrors();

            if (!this.weekday) {
                this.weekdayError = {
                    weekday: "Weekday field is required"
                };
            }

            if (!this.start_at) {
                this.fromError = {
                    from: "From field is required"
                };
            }

            if (!this.start_at) {
                this.toError = {
                    to: "To field is required"
                };
            }

            if (this.weekday && this.start_at && this.end_at) {
                let obj = {
                    weekday: this.weekday,
                    start_at: this.start_at,
                    end_at: this.end_at
                };
                this.periods.push(obj);
            }
        },

        addCountry(selectedOption) {
            this.keyword.except_countries.push(selectedOption);
        },

        removePeriod(index) {
            this.periods.splice(index, 1);
        },

        removeCountry(countryToDelete) {
            this.keyword.except_countries = this.keyword.except_countries.filter(
                country => country !== countryToDelete
            );
        },

        clearErrors() {
            this.weekdayError = {};
            this.fromError = {};
            this.toError = {};
        },

        addMinusKeyword() {
            if (this.minus_keyword) {
                this.keyword.minus_keywords.push(this.minus_keyword);
                this.minus_keyword = null;
            }
        },

        removeMinusKeyword(index) {
            this.keyword.minus_keywords.splice(index, 1);
        },

        save() {
            let allErrors = {};
            window.axios
                .put("api/keywords/" + this.id, {
                    keyword: this.keyword,
                    proposal_send_periods: this.periods,
                    category_type_id: this.category_type.id,
                    notifications: this.notifications
                })
                .then(res => {
                    if (res.status === 200) {
                        this.$router.push({ name: "dashboard.keywords" });
                    }
                })
                .catch(errors => {
                    if (errors.response.status === 422) {
                        let validationErrors = errors.response.data.errors;
                        Object.keys(validationErrors).forEach(function(key) {
                            allErrors[key] = validationErrors[key];
                        });

                        this.errors = allErrors;
                    }
                });
        }
    },
    computed: {
        timeFrom() {
            if (this.to) {
                let index = this.time.indexOf(this.to);
                return this.time.slice(0, index + 1);
            }
            return this.time;
        },
        timeTo() {
            if (this.from) {
                let index = this.time.indexOf(this.from);
                return this.time.slice(index, this.time.length + 1);
            }
            return this.time;
        }
    },
    watch: {
        "keyword.platform": function(newVal) {
            if (newVal === "upwork") {
                this.isUpworkPlatform = true;
            } else {
                this.isUpworkPlatform = false;
            }
        }
    },
    mounted() {
        this.getData();
        this.getCategoryTypes();

        if (this.keyword.platform === "upwork") {
            this.isUpworkPlatform = true;
        } else {
            this.isUpworkPlatform = false;
        }
    }
};
</script>

<style scoped lang="scss">
ul,
p {
    margin: 0;
    padding: 0;
}
.edit-content {
    padding: 48px 0 100px;
}
.edit-top {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
}
.edit-title {
    font-size: 15px;
    font-weight: 700;
    line-height: normal;
    color: #000;
    // margin-bottom: 20px;

    span {
        color: #6fda44;
    }
}

label {
    display: block;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.2;
    color: #000;
}

.text-span {
    font-size: 15px;
    font-weight: 700;
    line-height: 1.2;
    color: #000;
}

.items {
    @media (max-width: 768.98px) {
        display: flex;
        flex-direction: column;
    }

    display: grid;
    grid-template-columns: auto;
    gap: 15px;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: auto;
    grid-template-areas:
        "item1 item1 item1 item1 item1 item4 item4 item4 item4 item4 item4 item4"
        "item2 item2 item2 item2 item2 item7 item7 item7 item7 item7 item7 item7"
        "item3 item3 item3 item3 item3 item7 item7 item7 item7 item7 item7 item7"
        "item6 item6 item6 item6 item6 item5 item5 item5 item5 item5 item5 item5"
        "item8 item8 item8 item8 item8 item8 item8 item8 item8 item8 item8 item8"
        "item9 item9 item9 item9 item9 item9 item9 item9 item9 item9 item9 item9"
        "item10 item10 item10 item10 item10 item10 item10 item10 item10 item10 item10 item10";

    @media (min-width: 992.98px) {
        grid-template-areas:
            "item1 item1 item1 item1 item1 item1 item4 item4 item4 item4 item4 item4"
            "item2 item2 item2 item2 item2 item2 item7 item7 item7 item7 item7 item7"
            "item3 item3 item3 item3 item3 item3 item7 item7 item7 item7 item7 item7"
            "item6 item6 item6 item6 item6 item6 item5 item5 item5 item5 item5 item5"
            "item8 item8 item8 item8 item8 item8 item9 item9 item9 item9 item9 item9"
            "item10 item10 item10 item10 item10 item10 item10 item10 item10 item10 item10 item10";
    }

    @media (min-width: 1280.98px) {
        grid-template-areas:
            "item1 item1 item1 item1 item1 item2 item2 item2 item4 item4 item4 item4"
            "item1 item1 item1 item1 item1 item3 item3 item3 item4 item4 item4 item4"
            "item5 item5 item6 item6 item6 item7 item7 item7 item7 item7 item7 item7"
            "item8 item8 item8 item8 item8 item9 item9 item9 item9 item9 item9 item9"
            "item10 item10 item10 item10 item10 item10 item10 item10 item10 item10 item10 item10";
    }

    &_not-upwork {
        grid-template-areas:
            "item1 item1 item1 item1 item1 item2 item2 item2 item2 item2 item2 item2"
            "item1 item1 item1 item1 item1 item3 item3 item3 item3 item3 item3 item3"
            "item7 item7 item7 item7 item7 item9 item9 item9 item9 item9 item9 item9"
            "item8 item8 item8 item8 item8 item8 item8 item8 item8 item8 item8 item8"
            "item10 item10 item10 item10 item10 item10 item10 item10 item10 item10 item10 item10";
    }
}
.item {
    color: #000;
    background-color: #f4f4f4;
    border-radius: 20px;
    padding: 22px 21px 22px 31px;
}
.item-1 {
    grid-area: item1;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    &__content {
        flex: 1 1 auto;
    }

    &__body {
        width: 219px;
        display: flex;
        flex-direction: column;
        row-gap: 21px;
    }

    &__line {
        label {
            margin-bottom: 17px;
        }
        select {
            width: 100%;
        }
    }

    &__box {
        display: flex;
        gap: 29px;

        label {
            margin-bottom: 6px;
        }

        div {
            flex: 0 0 95px;
        }
    }

    &__add-button {
        align-self: flex-end;
    }

    &__items {
        margin-top: 24px;
        display: flex;
        flex-direction: column;
    }

    &__item {
        display: flex;
        justify-content: space-between;
        column-gap: 15px;
        color: #263238;
        font-size: 15px;
        font-weight: 500;
        line-height: 143.4%; /* 21.51px */
        &:not(:last-child) {
            margin-bottom: 8px;
        }

        strong {
            font-weight: 700;
        }

        img {
            cursor: pointer;
        }
    }
}

.item-2 {
    grid-area: item2;
    &__line {
        label {
            margin-bottom: 17px;
        }
        select {
            width: 100%;
        }
    }

    .items_not-upwork & {
        &__line {
            max-width: 219px;
        }
    }
}
.item-3 {
    grid-area: item3;
    &__line {
        label {
            margin-bottom: 17px;
        }
        select {
            width: 100%;
        }
    }

    .items_not-upwork & {
        &__line {
            max-width: 219px;
        }
    }
}
.item-4 {
    grid-area: item4;
    &__line {
        max-width: 219px;
        &:not(:last-child) {
            margin-bottom: 13px;
        }
        label {
            margin-bottom: 17px;
        }
        select {
            width: 100%;
        }
    }
    &__items {
        display: flex;
        flex-wrap: wrap;
        column-gap: 5px;
        row-gap: 7px;

        @media (min-width: 768.98px) {
            max-width: 434px;
        }
    }
    &__item {
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1 0 135px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 8px;
        padding: 6px 8px 6px 16px;
        font-size: 15px;
        font-weight: 400;
        line-height: 1.2;
        color: #fff;
        background-color: #263238;
        border-radius: 5px;
        cursor: pointer;

        img {
            width: 15px;
            height: 15px;
        }
    }
}
.item-5 {
    grid-area: item5;
    &__line {
        label {
            margin-bottom: 17px;
        }
        img {
            width: 137px;
        }
    }
}
.item-6 {
    grid-area: item6;
    &__line {
        label {
            margin-bottom: 17px;
        }
        select {
            width: 100%;
        }
    }
}
.item-7 {
    grid-area: item7;
    &__line {
        max-width: 219px;
        &:not(:last-child) {
            margin-bottom: 13px;
        }
        label {
            margin-bottom: 17px;
        }
        select {
            width: 100%;
        }
    }
    &__items {
        max-width: 434px;
        display: flex;
        flex-wrap: wrap;
        column-gap: 10px;
        row-gap: 7px;
    }
    &__item {
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1 0 135px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 8px;
        padding: 6px 8px 6px 16px;
        font-size: 15px;
        font-weight: 400;
        line-height: 1.2;
        color: #fff;
        background-color: #263238;
        border-radius: 5px;
        cursor: pointer;

        img {
            width: 15px;
            height: 15px;
        }
    }
}
.item-8 {
    grid-area: item8;
    &__label {
        margin-bottom: 20px;
    }
    &__line {
        display: grid;
        row-gap: 10px;
        &:not(:last-child) {
            margin-bottom: 16px;
        }
    }
    &__box {
        display: flex;
        align-items: center;
        column-gap: 15px;
    }

    &__input {
        font-weight: 500;
    }
    
    &__notification-instruction {
        display: flex;
        align-items: flex-start;
        padding: 10px 10px 0;
        &__text {
            font-size: 13px;
            text-align: justify;
            margin-left: 12px;
        }
    }
}
.item-9 {
    grid-area: item9;
    padding: 0;
    &__top {
        padding: 22px 21px 22px 31px;
        &:not(:last-child) {
            margin-bottom: 42px;
        }
    }
    &__label {
        margin-bottom: 23px;
    }
    &__line {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 16px 23px;
        &:not(:last-child) {
            margin-bottom: 16px;
        }
    }

    &__bottom {
        padding: 22px 21px 22px 31px;
        background-color: #fff;
    }

    &__bottom-text {
        margin-bottom: 20px;
    }

    &__items {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px 50px;
    }

    &__item {
        display: flex;
        align-items: center;

        &__cover-letter {
            margin-top: 20px;
        }
    }

    &__checkbox {
        width: 116px;
    }

    &__input {
        margin-left: 17px;

        input {
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
                -webkit-appearance: none;
            }

            &:hover,
            &:focus {
                appearance: none;
                -moz-appearance: textfield;
            }
        }
    }
}

.item-10 {
    grid-area: item10;
    padding: 0;
    background-color: #ffff;
    &__label {
        margin-bottom: 13px;
    }
    &__line {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 30px;
    }
    &__name {
        flex: 0 1 197px;
        padding: 6px 16px;
        font-size: 15px;
        font-weight: 700;
        line-height: 1.2;
        color: #000;
        background-color: #fbfbfb;
        border-radius: 5px;
    }
    &__input {
        max-width: 197px;
        font-weight: 700;
    }
    &__box {
        display: flex;
        align-items: center;
        column-gap: 13px;
    }
}

.save-btn {
    margin-top: 24px;
}
</style>
